import React, { useState } from 'react';
import { Users, Settings, FileText, MessageSquare, BarChart2, Book, Layout, ChevronRight, Menu, X, LogOut } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Card } from '../ui/Card';
import { SettingsPage } from './SettingsPage';
import { TermsOfServicePage } from './TermsOfServicePage';
export const AdminPanel = () => {
  const {
    language
  } = useLanguage();
  const isRTL = language === 'ar';
  const [activeTab, setActiveTab] = useState('dashboard');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarItems = [{
    id: 'dashboard',
    icon: <BarChart2 className="w-5 h-5" data-id="element-15" />,
    titleEn: 'Dashboard',
    titleAr: 'لوحة التحكم'
  }, {
    id: 'users',
    icon: <Users className="w-5 h-5" data-id="element-16" />,
    titleEn: 'Users',
    titleAr: 'المستخدمين'
  }, {
    id: 'courses',
    icon: <Book className="w-5 h-5" data-id="element-17" />,
    titleEn: 'Courses',
    titleAr: 'الدورات'
  }, {
    id: 'messages',
    icon: <MessageSquare className="w-5 h-5" data-id="element-18" />,
    titleEn: 'Messages',
    titleAr: 'الرسائل'
  }, {
    id: 'terms',
    icon: <FileText className="w-5 h-5" data-id="element-19" />,
    titleEn: 'Terms of Service',
    titleAr: 'شروط الخدمة'
  }, {
    id: 'settings',
    icon: <Settings className="w-5 h-5" data-id="element-20" />,
    titleEn: 'Settings',
    titleAr: 'الإعدادات'
  }];
  return <div className="min-h-screen bg-gray-50 dark:bg-gray-900" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-21">
      {/* Top Navigation */}
      <nav className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 fixed w-full top-0 z-30" data-id="element-22">
        <div className="px-4 sm:px-6" data-id="element-23">
          <div className="flex items-center justify-between h-16" data-id="element-24">
            <div className="flex items-center" data-id="element-25">
              <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="p-2 rounded-lg text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-500 lg:hidden" data-id="element-26">
                {isSidebarOpen ? <X className="w-6 h-6" data-id="element-27" /> : <Menu className="w-6 h-6" data-id="element-28" />}
              </button>
              <div className="flex items-center" data-id="element-29">
                <Layout className="w-8 h-8 text-primary-600 dark:text-primary-400" data-id="element-30" />
                <span className="text-xl font-semibold text-gray-900 dark:text-white ms-3" data-id="element-31">
                  {isRTL ? 'لوحة الإدارة' : 'Admin Panel'}
                </span>
              </div>
            </div>
            <div className="flex items-center gap-4" data-id="element-32">
              <button className="flex items-center gap-2 px-4 py-2 text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-colors" data-id="element-33">
                <LogOut className="w-5 h-5" data-id="element-34" />
                <span data-id="element-35">{isRTL ? 'تسجيل الخروج' : 'Logout'}</span>
              </button>
            </div>
          </div>
        </div>
      </nav>
      {/* Sidebar */}
      <aside className={`fixed inset-y-0 ${isRTL ? 'right-0' : 'left-0'} z-20 w-64 bg-white dark:bg-gray-800 border-${isRTL ? 'l' : 'r'} border-gray-200 dark:border-gray-700 transform lg:translate-x-0 transition-transform duration-300 ${isSidebarOpen ? 'translate-x-0' : `${isRTL ? 'translate-x-64' : '-translate-x-64'}`} lg:pt-16`} data-id="element-36">
        <div className="h-full pt-5 pb-4 overflow-y-auto" data-id="element-37">
          <nav className="mt-5 px-2 space-y-1" data-id="element-38">
            {sidebarItems.map(item => <button key={item.id} onClick={() => {
            setActiveTab(item.id);
            setIsSidebarOpen(false);
          }} className={`group flex items-center gap-x-3 px-4 py-3 w-full rounded-lg transition-colors ${activeTab === item.id ? 'bg-primary-50 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800'}`} data-id="element-39">
                {item.icon}
                <span className="text-sm font-medium" data-id="element-40">
                  {isRTL ? item.titleAr : item.titleEn}
                </span>
                <ChevronRight className={`w-4 h-4 ms-auto transition-transform ${activeTab === item.id ? 'rotate-90' : ''} ${isRTL ? 'rotate-180' : ''}`} data-id="element-41" />
              </button>)}
          </nav>
        </div>
      </aside>
      {/* Main Content */}
      <main className={`pt-16 lg:${isRTL ? 'mr-64' : 'ml-64'} min-h-screen transition-all duration-300`} data-id="element-42">
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8" data-id="element-43">
          {activeTab === 'settings' && <SettingsPage data-id="element-44" />}
          {activeTab === 'terms' && <TermsOfServicePage data-id="element-45" />}
          {activeTab === 'dashboard' && <Card data-id="element-46">
              <div className="p-6" data-id="element-47">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-48">
                  {isRTL ? 'لوحة التحكم' : 'Dashboard'}
                </h2>
                <p className="text-gray-600 dark:text-gray-400" data-id="element-49">
                  {isRTL ? 'مرحباً بك في لوحة التحكم الخاصة بك' : 'Welcome to your dashboard'}
                </p>
              </div>
            </Card>}
          {/* Add other tab content components here */}
        </div>
      </main>
      {/* Backdrop */}
      {isSidebarOpen && <div className="fixed inset-0 bg-gray-900/50 z-10 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-50" />}
    </div>;
};